// src/contexts/Theme.context.jsx

'use client'

import { createTheme } from '@mui/material/styles';


// Define the brand colors based on your CSS variables
export const theme = createTheme({
  palette: {
    primary: {
      light: 'hsl(90, 10%, 55%)', // --primary-400
      main: 'hsl(90, 10%, 36%)', // --primary-600 (ebony base)
      dark: 'hsl(90, 10%, 20%)', // --primary-900
    },
    secondary: {
      light: 'hsl(28, 51%, 55%)', // --secondary-400
      main: 'hsl(28, 51%, 46%)', // --secondary-500 (copper base)
      dark: 'hsl(28, 51%, 30%)', // --secondary-700
    },
    background: {
      default: 'hsl(240, 12%, 95%)', // --background-50
      paper: '#ffffff',
    },
    text: {
      primary: 'hsl(340, 6%, 10%)', // --text-900
      secondary: 'hsl(347, 6%, 30%)', // --text-700
    },
    // --- Add Alert Color Overrides ---
    error: {
      // Uses --caput-mortuum (Dark Red)
      main: 'hsl(12, 75%, 19%)',
      // Use a light text for contrast against the dark red
      contrastText: 'hsl(340, 6%, 90%)', // --text-100
    },
    warning: {
      // Uses --copper (Orange-Brown)
      main: 'hsl(28, 51%, 46%)',
      // Use a light text for contrast against the dark orange-brown
      contrastText: 'hsl(340, 6%, 90%)', // --text-100
    },
    info: {
      // Uses --bone (Beige) as the closest distinct/neutral option (no blue available)
      main: 'hsl(39, 29%, 79%)',
      // Use a dark text for contrast against the light beige
      contrastText: 'hsl(340, 6%, 10%)', // --text-900
    },
    success: {
      // Uses --ebony (Green-Gray)
      main: 'hsl(90, 10%, 36%)',
      // Use a light text for contrast against the dark green-gray
      contrastText: 'hsl(340, 6%, 90%)', // --text-100
    },
  },
});
